import {waitForTrans} from './utils';

// TODO: refactor jQuery --> ES
export default class ZipCode {
	constructor(app) {
		this.app = app;
		const self = this;

		self.countryPatterns = self.getCountryPatterns();
		self.bonesMap = self.getBonesMap();

		for (let countryBone in self.bonesMap) {
			$(document).on('change', 'select[name="' + countryBone + '"]',
				(e) => self.changedCountry($(e.currentTarget).val(), self, countryBone)
			);
			self.changedCountry($('select[name="' + countryBone + '"]').val(), self, countryBone); // init correctly
		}

	}

	changedCountry(val, self, countryBone) {
		if (val in self.countryPatterns) {
			let countryPattern = self.countryPatterns[val];
			let zipBone = self.bonesMap[countryBone];
			let $zipBone = $('input[name="' + zipBone + '"]');
			let $zipInputGroup = $zipBone.closest('.input-group');

			$zipBone.attr('pattern', countryPattern['regex'])
			if (!($zipBone.val() || '').match(new RegExp(`^${countryPattern['regex']}$`))) {
				$zipBone.val(countryPattern['regex'] === countryPattern['example'] ? countryPattern['example'] : '');
			}

			waitForTrans(() => {
				$zipInputGroup.attr('aria-label', `${self.app.info.translations["tooltip-zipcode"]} ${countryPattern['example']}`);
			});
		}
	}


	/**
	 * Bones Map
	 * maps a country-Bone to the according zip-one
	 */
	getBonesMap() {
		return {
			'bill_country': 'bill_zip',
			'shipping_country': 'shipping_zip',
			// 'country': 'zip_code', //FIXME
			'country': 'zipcode',
		}
	}

	getCountryPatterns() {
		return {
			"gw": {"regex": "\\d{4}", "example": "1000,1011"},
			"gu": {"regex": "(969(?:[12]\\d|3[12]))(?:[ \-](\\d{4}))?", "example": "96910,96931"},
			"gt": {"regex": "\\d{5}", "example": "09001,01501"},
			"gr": {"regex": "\\d{3} ?\\d{2}", "example": "151 24,151 10,101 88"},
			"gq": {"regex": "", "example": ""},
			"gy": {"regex": "", "example": ""},
			"gg": {"regex": "GY\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}", "example": "GY1 1AA,GY2 2BT"},
			"ge": {"regex": "\\d{4}", "example": "0101"},
			"gd": {"regex": "", "example": ""},
			"gb": {
				"regex": "GIR ?0AA|(?:(?:AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|BX|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(?:\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}))|BFPO ?\\d{1,4}",
				"example": "EC1Y 8SY,GIR 0AA,M2 5BQ,M34 4AB,CR0 2YR,DN16 9AA,W1A 4ZZ,EC1A 1HQ,OX14 4PG,BS18 8HF,NR25 7HG,RH6 0NP,BH23 6AA,B6 5BA,SO23 9AP,PO1 3AX,BFPO 61"
			},
			"ga": {"regex": "", "example": ""},
			"gn": {"regex": "\\d{3}", "example": "001,200,100"},
			"gm": {"regex": "", "example": ""},
			"gl": {"regex": "39\\d{2}", "example": "3900,3950,3911"},
			"gi": {"regex": "GX11 1AA", "example": "GX11 1AA"},
			"gh": {"regex": "", "example": ""},
			"tz": {"regex": "\\d{4,5}", "example": "6090,34413"},
			"tv": {"regex": "", "example": ""},
			"tw": {"regex": "\\d{3}(?:\\d{2})?", "example": "104,106,10603,40867"},
			"tt": {"regex": "", "example": ""},
			"tr": {"regex": "\\d{5}", "example": "01960,06101"},
			"tn": {"regex": "\\d{4}", "example": "1002,8129,3100,1030"},
			"to": {"regex": "", "example": ""},
			"tl": {"regex": "", "example": ""},
			"tm": {"regex": "\\d{6}", "example": "744000"},
			"tj": {"regex": "\\d{6}", "example": "735450,734025"},
			"tk": {"regex": "", "example": ""},
			"th": {"regex": "\\d{5}", "example": "10150,10210"},
			"tf": {"regex": "", "example": ""},
			"tg": {"regex": "", "example": ""},
			"td": {"regex": "", "example": ""},
			"tc": {"regex": "TKCA 1ZZ", "example": "TKCA 1ZZ"},
			"do": {"regex": "\\d{5}", "example": "11903,10101"},
			"dm": {"regex": "", "example": ""},
			"dj": {"regex": "", "example": ""},
			"dk": {"regex": "\\d{4}", "example": "8660,1566"},
			"de": {"regex": "\\d{5}", "example": "26133,53225"},
			"dz": {"regex": "\\d{5}", "example": "40304,16027"},
			"qa": {"regex": "", "example": ""},
			"zm": {"regex": "\\d{5}", "example": "50100,50101"},
			"za": {"regex": "\\d{4}", "example": "0083,1451,0001"},
			"zw": {"regex": "", "example": ""},
			"wf": {"regex": "986\\d{2}", "example": "98600"},
			"jp": {"regex": "\\d{3}-?\\d{4}", "example": "154-0023,350-1106,951-8073,112-0001,208-0032,231-0012"},
			"jm": {"regex": "", "example": ""},
			"jo": {"regex": "\\d{5}", "example": "11937,11190"},
			"ws": {"regex": "", "example": ""},
			"je": {"regex": "JE\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}", "example": "JE1 1AA,JE2 2BT"},
			"ck": {"regex": "", "example": ""},
			"ci": {"regex": "", "example": ""},
			"ch": {"regex": "\\d{4}", "example": "2544,1211,1556,3030"},
			"co": {"regex": "\\d{6}", "example": "111221,130001,760011"},
			"cn": {"regex": "\\d{6}", "example": "266033,317204,100096,100808"},
			"cm": {"regex": "", "example": ""},
			"cl": {"regex": "\\d{7}", "example": "8340457,8720019,1230000,8329100"},
			"cc": {"regex": "6799", "example": "6799"},
			"ca": {
				"regex": "[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z] ?\\d[ABCEGHJ-NPRSTV-Z]\\d",
				"example": "H3Z 2Y7,V8X 3X4,T0L 1K0,T0H 1A0,K1A 0B1"
			},
			"cg": {"regex": "", "example": ""},
			"cf": {"regex": "", "example": ""},
			"cd": {"regex": "", "example": ""},
			"cz": {"regex": "\\d{3} ?\\d{2}", "example": "100 00,251 66,530 87,110 00,225 99"},
			"cy": {"regex": "\\d{4}", "example": "2008,3304,1900"},
			"cx": {"regex": "6798", "example": "6798"},
			"cr": {"regex": "\\d{4,5}|\\d{3}-\\d{4}", "example": "1000,2010,1001"},
			"cv": {"regex": "\\d{4}", "example": "7600"},
			"cu": {"regex": "", "example": ""},
			"pr": {"regex": "(00[679]\\d{2})(?:[ \-](\\d{4}))?", "example": "00930"},
			"ps": {"regex": "", "example": ""},
			"pw": {"regex": "(969(?:39|40))(?:[ \-](\\d{4}))?", "example": "96940"},
			"pt": {"regex": "\\d{4}-\\d{3}", "example": "2725-079,1250-096,1201-950,2860-571,1208-148"},
			"py": {"regex": "\\d{4}", "example": "1536,1538,1209"},
			"pa": {"regex": "", "example": ""},
			"pf": {"regex": "987\\d{2}", "example": "98709"},
			"pg": {"regex": "\\d{3}", "example": "111"},
			"pe": {"regex": "(?:LIMA \\d{1,2}|CALLAO 0?\\d)|[0-2]\\d{4}", "example": "LIMA 23,LIMA 42,CALLAO 2,02001"},
			"pk": {"regex": "\\d{5}", "example": "44000"},
			"ph": {"regex": "\\d{4}", "example": "1008,1050,1135,1207,2000,1000"},
			"pn": {"regex": "PCRN 1ZZ", "example": "PCRN 1ZZ"},
			"pl": {"regex": "\\d{2}-\\d{3}", "example": "00-950,05-470,48-300,32-015,00-940"},
			"pm": {"regex": "9[78]5\\d{2}", "example": "97500"},
			"me": {"regex": "8\\d{4}", "example": "81257,81258,81217,84314,85366"},
			"md": {"regex": "\\d{4}", "example": "2012,2019"},
			"mg": {"regex": "\\d{3}", "example": "501,101"},
			"mf": {"regex": "9[78][01]\\d{2}", "example": "97100"},
			"ma": {"regex": "\\d{5}", "example": "53000,10000,20050,16052"},
			"mc": {"regex": "980\\d{2}", "example": "98000,98020,98011,98001"},
			"mm": {"regex": "\\d{5}", "example": "11181"},
			"ml": {"regex": "", "example": ""},
			"mo": {"regex": "", "example": ""},
			"mn": {"regex": "\\d{5}", "example": "65030,65270"},
			"mh": {"regex": "(969[67]\\d)(?:[ \-](\\d{4}))?", "example": "96960,96970"},
			"mk": {"regex": "\\d{4}", "example": "1314,1321,1443,1062"},
			"mu": {"regex": "\\d{3}(?:\\d{2}|[A-Z]{2}\\d{3})", "example": "42602"},
			"mt": {"regex": "[A-Z]{3} ?\\d{2,4}", "example": "NXR 01,ZTN 05,GPO 01,BZN 1130,SPB 6031,VCT 1753"},
			"mw": {"regex": "", "example": ""},
			"mv": {"regex": "\\d{5}", "example": "20026"},
			"mp": {"regex": "(9695[012])(?:[ \-](\\d{4}))?", "example": "96950,96951,96952"},
			"ms": {"regex": "", "example": ""},
			"mr": {"regex": "", "example": ""},
			"my": {"regex": "\\d{5}", "example": "43000,50754,88990,50670"},
			"mx": {"regex": "\\d{5}", "example": "02860,77520,06082"},
			"mz": {"regex": "\\d{4}", "example": "1102,1119,3212"},
			"va": {"regex": "00120", "example": "00120"},
			"vc": {"regex": "VC\\d{4}", "example": "VC0100,VC0110,VC0400"},
			"ve": {"regex": "\\d{4}", "example": "1010,3001,8011,1020"},
			"vg": {"regex": "VG\\d{4}", "example": "VG1110,VG1150,VG1160"},
			"iq": {"regex": "\\d{5}", "example": "31001"},
			"vi": {"regex": "(008(?:(?:[0-4]\\d)|(?:5[01])))(?:[ \-](\\d{4}))?", "example": "00802-1222,00850-9802"},
			"is": {"regex": "\\d{3}", "example": "320,121,220,110"},
			"ir": {"regex": "\\d{5}-?\\d{5}", "example": "11936-12345"},
			"it": {"regex": "\\d{5}", "example": "00144,47037,39049"},
			"vn": {"regex": "\\d{6}", "example": "119415,136065,720344"},
			"im": {"regex": "IM\\d[\\dA-Z]? ?\\d[ABD-HJLN-UW-Z]{2}", "example": "IM2 1AA,IM99 1PS"},
			"vu": {"regex": "", "example": ""},
			"io": {"regex": "BBND 1ZZ", "example": "BBND 1ZZ"},
			"in": {"regex": "\\d{6}", "example": "110034,110001"},
			"ie": {"regex": "[\\dA-Z]{3} ?[\\dA-Z]{4}", "example": "A65 F4E2"},
			"id": {"regex": "\\d{5}", "example": "40115"},
			"il": {"regex": "\\d{5}(?:\\d{2})?", "example": "9614303"},
			"fr": {"regex": "\\d{2} ?\\d{3}", "example": "33380,34092,33506"},
			"fi": {"regex": "\\d{5}", "example": "00550,00011"},
			"fj": {"regex": "", "example": ""},
			"fk": {"regex": "FIQQ 1ZZ", "example": "FIQQ 1ZZ"},
			"fm": {"regex": "(9694[1-4])(?:[ \-](\\d{4}))?", "example": "96941,96944"},
			"fo": {"regex": "\\d{3}", "example": "100"},
			"sz": {"regex": "[HLMS]\\d{3}", "example": "H100"},
			"sy": {"regex": "", "example": ""},
			"sr": {"regex": "", "example": ""},
			"sv": {"regex": "CP [1-3][1-7][0-2]\\d", "example": "CP 1101"},
			"st": {"regex": "", "example": ""},
			"sk": {"regex": "\\d{3} ?\\d{2}", "example": "010 01,023 14,972 48,921 01,975 99"},
			"sj": {"regex": "\\d{4}", "example": "9170"},
			"si": {"regex": "\\d{4}", "example": "4000,1001,2500"},
			"sh": {"regex": "(?:ASCN|STHL) 1ZZ", "example": "STHL 1ZZ"},
			"so": {"regex": "[A-Z]{2} ?\\d{5}", "example": "JH 09010,AD 11010"},
			"sn": {"regex": "\\d{5}", "example": "12500,46024,16556,10000"},
			"sm": {"regex": "4789\\d", "example": "47890,47891,47895,47899"},
			"sl": {"regex": "", "example": ""},
			"sc": {"regex": "", "example": ""},
			"sb": {"regex": "", "example": ""},
			"sa": {"regex": "\\d{5}", "example": "11564,11187,11142"},
			"sg": {"regex": "\\d{6}", "example": "546080,308125,408600"},
			"se": {"regex": "\\d{3} ?\\d{2}", "example": "11455,12345,10500"},
			"sd": {"regex": "", "example": ""},
			"lb": {"regex": "(?:\\d{4})(?: ?(?:\\d{4}))?", "example": "2038 3054,1107 2810,1000"},
			"lc": {"regex": "", "example": ""},
			"la": {"regex": "\\d{5}", "example": "01160,01000"},
			"lk": {"regex": "\\d{5}", "example": "20000,00100"},
			"li": {"regex": "948[5-9]|949[0-7]", "example": "9496,9491,9490,9485"},
			"lv": {"regex": "LV-\\d{4}", "example": "LV-1073,LV-1000"},
			"lt": {"regex": "\\d{5}", "example": "04340,03500"},
			"lu": {"regex": "\\d{4}", "example": "4750,2998"},
			"lr": {"regex": "\\d{4}", "example": "1000"},
			"ls": {"regex": "\\d{3}", "example": "100"},
			"ly": {"regex": "", "example": ""},
			"ye": {"regex": "", "example": ""},
			"yt": {"regex": "976\\d{2}", "example": "97600"},
			"eh": {"regex": "\\d{5}", "example": "70000,72000"},
			"ee": {"regex": "\\d{5}", "example": "69501,11212"},
			"eg": {"regex": "\\d{5}", "example": "12411,11599"},
			"ec": {"regex": "\\d{6}", "example": "090105,092301"},
			"et": {"regex": "\\d{4}", "example": "1000"},
			"es": {"regex": "\\d{5}", "example": "28039,28300,28070"},
			"er": {"regex": "", "example": ""},
			"ru": {"regex": "\\d{6}", "example": "247112,103375,188300"},
			"rw": {"regex": "", "example": ""},
			"rs": {"regex": "\\d{5,6}", "example": "106314"},
			"ro": {"regex": "\\d{6}", "example": "060274,061357,200716"},
			"bd": {"regex": "\\d{4}", "example": "1340,1000"},
			"be": {"regex": "\\d{4}", "example": "4000,1000"},
			"bf": {"regex": "", "example": ""},
			"bg": {"regex": "\\d{4}", "example": "1000,1700"},
			"ba": {"regex": "\\d{5}", "example": "71000"},
			"bb": {"regex": "BB\\d{5}", "example": "BB23026,BB22025"},
			"bl": {"regex": "9[78][01]\\d{2}", "example": "97100"},
			"bm": {"regex": "[A-Z]{2} ?[A-Z0-9]{2}", "example": "FL 07,HM GX,HM 12"},
			"bn": {"regex": "[A-Z]{2} ?\\d{4}", "example": "BT2328,KA1131,BA1511"},
			"bo": {"regex": "", "example": ""},
			"bh": {"regex": "(?:\\d|1[0-2])\\d{2}", "example": "317"},
			"bi": {"regex": "", "example": ""},
			"bj": {"regex": "", "example": ""},
			"bt": {"regex": "\\d{5}", "example": "11001,31101,35003"},
			"bv": {"regex": "", "example": ""},
			"bw": {"regex": "", "example": ""},
			"br": {"regex": "\\d{5}-?\\d{3}", "example": "40301-110,70002-900"},
			"bs": {"regex": "", "example": ""},
			"by": {"regex": "\\d{6}", "example": "223016,225860,220050"},
			"bz": {"regex": "", "example": ""},
			"om": {"regex": "(?:PC )?\\d{3}", "example": "133,112,111"},
			"hr": {"regex": "\\d{5}", "example": "10000,21001,10002"},
			"ht": {"regex": "\\d{4}", "example": "6120,5310,6110,8510"},
			"hu": {"regex": "\\d{4}", "example": "1037,2380,1540"},
			"hk": {"regex": "", "example": ""},
			"hn": {"regex": "\\d{5}", "example": "31301"},
			"hm": {"regex": "\\d{4}", "example": "7050"},
			"uy": {"regex": "\\d{5}", "example": "11600"},
			"uz": {"regex": "\\d{6}", "example": "702100,700000"},
			"us": {"regex": "(\\d{5})(?:[ \-](\\d{4}))?", "example": "95014,22162-1010"},
			"ug": {"regex": "", "example": ""},
			"ua": {"regex": "\\d{5}", "example": "15432,01055,01001"},
			"ae": {"regex": "", "example": ""},
			"ad": {"regex": "AD[1-7]0\\d", "example": "AD100,AD501,AD700"},
			"ag": {"regex": "", "example": ""},
			"af": {"regex": "\\d{4}", "example": "1001,2601,3801"},
			"ai": {"regex": "(?:AI-)?2640", "example": "2640"},
			"am": {"regex": "(?:37)?\\d{4}", "example": "375010,0002,0010"},
			"al": {"regex": "\\d{4}", "example": "1001,1017,3501"},
			"ao": {"regex": "", "example": ""},
			"an": {"regex": "", "example": ""},
			"aq": {"regex": "", "example": ""},
			"as": {"regex": "(96799)(?:[ \-](\\d{4}))?", "example": "96799"},
			"ar": {"regex": "((?:[A-HJ-NP-Z])?\\d{4})([A-Z]{3})?", "example": "C1070AAM,C1000WAM,B1000TBU,X5187XAB"},
			"au": {"regex": "\\d{4}", "example": "2060,3171,6430,4000,4006,3001"},
			"at": {"regex": "\\d{4}", "example": "1010,3741"},
			"aw": {"regex": "", "example": ""},
			"az": {"regex": "\\d{4}", "example": "1000"},
			"ni": {"regex": "\\d{5}", "example": "52000"},
			"nl": {"regex": "\\d{4}\\s*[A-Z]{2}", "example": "1234 AB,2490 AA"},
			"no": {"regex": "\\d{4}", "example": "0025,0107,6631"},
			"na": {"regex": "", "example": ""},
			"nc": {"regex": "988\\d{2}", "example": "98814,98800,98810"},
			"ne": {"regex": "\\d{4}", "example": "8001"},
			"nf": {"regex": "2899", "example": "2899"},
			"ng": {"regex": "\\d{6}", "example": "930283,300001,931104"},
			"nz": {"regex": "\\d{4}", "example": "6001,6015,6332,8252,1030"},
			"np": {"regex": "\\d{5}", "example": "44601"},
			"nr": {"regex": "", "example": ""},
			"nu": {"regex": "", "example": ""},
			"kg": {"regex": "\\d{6}", "example": "720001"},
			"ke": {"regex": "\\d{5}", "example": "20100,00100"},
			"ki": {"regex": "", "example": ""},
			"kh": {"regex": "\\d{5}", "example": "12203,14206,12000"},
			"kn": {"regex": "", "example": ""},
			"km": {"regex": "", "example": ""},
			"kr": {"regex": "\\d{5}", "example": "03051"},
			"kp": {"regex": "", "example": ""},
			"kw": {"regex": "\\d{5}", "example": "54541,54551,54404,13009"},
			"kz": {"regex": "\\d{6}", "example": "040900,050012"},
			"ky": {"regex": "KY\\d-\\d{4}", "example": "KY1-1100,KY1-1702,KY2-2101"},
		}
	}
}
